// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * ipam.css — Theme-aware overrides for all IPAM / Network components.
 * Scoped under .ipam-root to avoid bleeding into other modules.
 * Overrides Bootstrap 5 defaults for: cards, tables, nav-tabs, forms, badges.
 */

/* ── Root wrapper ─────────────────────────────────────────────── */
/* OJO: aquí NO se pinta fondo. El módulo hereda el del layout, igual que el
   resto de listados del CMDB. Antes ponía \`background: var(--slate-50)\` en
   \`.ipam-root\` y en \`.ipam-root > .p-3\`, que sobre los skins oscuros dejaba un
   rectángulo más oscuro que la página (se veía como un fondo raro que en las
   demás pantallas no aparece). */
.ipam-root {
  color: var(--text-primary);
  min-height: 100%;
}

/* ── IPAM Header (tab bar) ────────────────────────────────────── */
.ipam-header {
  background: var(--bg-card) !important;
  border-bottom: 1px solid var(--border) !important;
}

.ipam-header h5 {
  color: var(--text-primary) !important;
}

/* ── Nav Tabs ─────────────────────────────────────────────────── */
.ipam-root .nav-tabs {
  border-bottom-color: var(--border) !important;
}

.ipam-root .nav-tabs .nav-link {
  color: var(--text-muted) !important;
  border-color: transparent !important;
  background: transparent !important;
}

.ipam-root .nav-tabs .nav-link:hover {
  color: var(--text-secondary) !important;
  border-color: transparent !important;
  background: var(--bg-toolbar) !important;
}

.ipam-root .nav-tabs .nav-link.active {
  color: var(--accent-l) !important;
  background: transparent !important;
  border-bottom: 2px solid var(--accent) !important;
  border-top-color: transparent !important;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  font-weight: 700 !important;
}

/* ── Page padding wrapper ─────────────────────────────────────── */
/* Sin fondo propio: ver la nota de \`.ipam-root\`. */
.ipam-root > .p-3 {
  background: transparent;
}

/* ── Bootstrap cards ──────────────────────────────────────────── */
.ipam-root .card {
  background: var(--bg-card) !important;
  border-color: var(--border) !important;
  color: var(--text-primary) !important;
}

.ipam-root .card-header {
  background: var(--bg-toolbar) !important;
  border-bottom-color: var(--border) !important;
  color: var(--text-primary) !important;
}

.ipam-root .card-header strong {
  color: var(--text-primary) !important;
}

.ipam-root .card-body {
  background: transparent !important;
  color: var(--text-primary) !important;
}

/* ── List groups (block occupancy) ───────────────────────────── */
.ipam-root .list-group-item {
  background: transparent !important;
  border-color: var(--border) !important;
  color: var(--text-primary) !important;
}

.ipam-root .list-group-item:hover {
  background: rgba(var(--accent-rgb),.07) !important;
  cursor: pointer;
}

.ipam-root .list-group-item .text-muted {
  color: var(--text-muted) !important;
}

/* ── Progress bars ────────────────────────────────────────────── */
.ipam-root .progress {
  background: var(--bg-toolbar) !important;
}

/* ── Tables ───────────────────────────────────────────────────── */
.ipam-root .table {
  color: var(--text-primary) !important;
  --bs-table-bg: transparent !important;
  --bs-table-striped-bg: var(--bg-toolbar) !important;
  --bs-table-hover-bg: rgba(var(--accent-rgb),.07) !important;
  --bs-table-border-color: var(--border) !important;
}

.ipam-root .table-light,
.ipam-root thead.table-light,
.ipam-root thead th.table-light,
.ipam-root .table thead,
.ipam-root .table thead tr {
  /* \`--bg-surface\` (opaco), no \`--bg-toolbar\`: la cabecera es sticky y con un
     fondo translúcido se ven las filas por debajo al hacer scroll. */
  --bs-table-bg: var(--bg-surface) !important;
  background: var(--bg-surface) !important;
  color: var(--text-secondary) !important;
}

.ipam-root .table thead th {
  background: var(--bg-surface) !important;
  color: var(--text-secondary) !important;
  border-bottom-color: var(--border) !important;
  font-size: 0.78em;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.ipam-root .table td,
.ipam-root .table th {
  border-color: var(--border) !important;
}

.ipam-root .table tbody tr:hover td {
  background: rgba(var(--accent-rgb),.07) !important;
}

/* ── Form controls ────────────────────────────────────────────── */
.ipam-root .form-control,
.ipam-root .form-select {
  background: var(--bg-input) !important;
  color: var(--text-primary) !important;
  border-color: var(--border) !important;
}

.ipam-root .form-control:focus,
.ipam-root .form-select:focus {
  background: var(--bg-input) !important;
  color: var(--text-primary) !important;
  border-color: var(--accent) !important;
  box-shadow: 0 0 0 3px rgba(var(--accent-rgb),.2) !important;
}

.ipam-root .form-control::placeholder {
  color: var(--text-muted) !important;
}

.ipam-root .form-select option,
.ipam-root .form-control option {
  background: var(--bg-surface);
  color: var(--text-primary);
}

.ipam-root .form-label {
  color: var(--text-secondary) !important;
}

/* ── Alerts ───────────────────────────────────────────────────── */
.ipam-root .alert-danger {
  background: rgba(220,38,38,.12) !important;
  border-color: rgba(220,38,38,.25) !important;
  color: #f87171 !important;
}

/* ── Badges ───────────────────────────────────────────────────── */
.ipam-root .badge.text-bg-secondary {
  background: var(--bg-toolbar) !important;
  color: var(--text-secondary) !important;
}

.ipam-root .badge.text-bg-primary {
  background: rgba(var(--accent-rgb),.2) !important;
  color: var(--accent-l) !important;
}

.ipam-root .badge.text-bg-info {
  background: rgba(6,182,212,.15) !important;
  color: #67e8f9 !important;
}

.ipam-root .badge.text-bg-warning {
  background: rgba(245,158,11,.15) !important;
  color: #fcd34d !important;
}

.ipam-root .badge.text-bg-success {
  background: rgba(16,185,129,.15) !important;
  color: #6ee7b7 !important;
}

.ipam-root .badge.text-bg-danger {
  background: rgba(239,68,68,.15) !important;
  color: #fca5a5 !important;
}

/* ── Text muted ────────────────────────────────────────────────── */
.ipam-root .text-muted {
  color: var(--text-muted) !important;
}

/* ── Buttons ──────────────────────────────────────────────────── */
.ipam-root .btn-outline-secondary {
  background: var(--bg-toolbar) !important;
  border-color: var(--border) !important;
  color: var(--text-secondary) !important;
}

.ipam-root .btn-outline-secondary:hover {
  background: var(--bg-input) !important;
  border-color: var(--slate-300) !important;
  color: var(--text-primary) !important;
}

.ipam-root .btn-outline-danger {
  background: rgba(239,68,68,.08) !important;
  border-color: rgba(239,68,68,.3) !important;
  color: #f87171 !important;
}

.ipam-root .btn-outline-danger:hover {
  background: rgba(239,68,68,.2) !important;
}

.ipam-root .btn-link {
  color: var(--accent-l) !important;
}

.ipam-root .btn-link:hover {
  color: var(--accent) !important;
}

/* ── KPI cards display text ─────────────────────────────────── */
.ipam-root .text-primary  { color: var(--accent-l) !important; }
.ipam-root .text-secondary { color: var(--text-muted) !important; }
.ipam-root .text-warning  { color: #fcd34d !important; }
.ipam-root .text-success  { color: #6ee7b7 !important; }
.ipam-root .text-danger   { color: #f87171 !important; }

/* ── Card hover shadow ────────────────────────────────────────── */
.ipam-root .card:hover {
  box-shadow: 0 0 0 1px rgba(var(--accent-rgb),.25) !important;
}

/* ── Monospace IP addresses ───────────────────────────────────── */
.ipam-root td [style*="monospace"],
.ipam-root td span[style*="fontFamily"] {
  color: var(--accent-l) !important;
}

/* ── VirtualGroups / generic Bootstrap overrides ─────────────── */
.ipam-root .bg-light,
.ipam-root .bg-white {
  background: var(--bg-toolbar) !important;
}

.ipam-root .border,
.ipam-root .border-end,
.ipam-root .border-bottom {
  border-color: var(--border) !important;
}

.ipam-root .table-active,
.ipam-root .table-active td {
  background: rgba(var(--accent-rgb),.1) !important;
  --bs-table-accent-bg: rgba(var(--accent-rgb),.1) !important;
}

.ipam-root .hover-bg:hover {
  background: rgba(var(--accent-rgb),.07) !important;
}

.ipam-root .btn-light {
  background: var(--bg-toolbar) !important;
  border-color: var(--border) !important;
  color: var(--text-secondary) !important;
}

.ipam-root .btn-light:hover {
  background: var(--bg-input) !important;
}

.ipam-root .bg-secondary.bg-opacity-15 {
  background: var(--bg-toolbar) !important;
}

.ipam-root .fw-semibold.text-muted.text-uppercase {
  color: var(--text-muted) !important;
}

.ipam-root .overflow-hidden.rounded.border {
  border-color: var(--border) !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/ipam.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF,oEAAoE;AACpE;;;;iCAIiC;AACjC;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,oEAAoE;AACpE;EACE,qCAAqC;EACrC,iDAAiD;AACnD;;AAEA;EACE,qCAAqC;AACvC;;AAEA,oEAAoE;AACpE;EACE,6CAA6C;AAC/C;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;EAClC,iDAAiD;EACjD,wCAAwC;EACxC,yCAAyC;EACzC,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA,oEAAoE;AACpE,mDAAmD;AACnD;EACE,uBAAuB;AACzB;;AAEA,oEAAoE;AACpE;EACE,qCAAqC;EACrC,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;EACxC,6CAA6C;EAC7C,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA,mEAAmE;AACnE;EACE,kCAAkC;EAClC,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,oEAAoE;AACpE;EACE,wCAAwC;AAC1C;;AAEA,oEAAoE;AACpE;EACE,qCAAqC;EACrC,qCAAqC;EACrC,mDAAmD;EACnD,2DAA2D;EAC3D,iDAAiD;AACnD;;AAEA;;;;;EAKE;qEACmE;EACnE,2CAA2C;EAC3C,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,6CAA6C;EAC7C,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;EACE,kDAAkD;AACpD;;AAEA,oEAAoE;AACpE;;EAEE,sCAAsC;EACtC,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;;EAEE,sCAAsC;EACtC,qCAAqC;EACrC,sCAAsC;EACtC,2DAA2D;AAC7D;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;AACzC;;AAEA,oEAAoE;AACpE;EACE,0CAA0C;EAC1C,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA,oEAAoE;AACpE;EACE,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA;EACE,iDAAiD;EACjD,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA,qEAAqE;AACrE;EACE,mCAAmC;AACrC;;AAEA,oEAAoE;AACpE;EACE,wCAAwC;EACxC,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;EACtC,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,kEAAkE;AAClE,4BAA4B,iCAAiC,EAAE;AAC/D,6BAA6B,mCAAmC,EAAE;AAClE,4BAA4B,yBAAyB,EAAE;AACvD,4BAA4B,yBAAyB,EAAE;AACvD,4BAA4B,yBAAyB,EAAE;;AAEvD,oEAAoE;AACpE;EACE,4DAA4D;AAC9D;;AAEA,oEAAoE;AACpE;;EAEE,iCAAiC;AACnC;;AAEA,mEAAmE;AACnE;;EAEE,wCAAwC;AAC1C;;AAEA;;;EAGE,sCAAsC;AACxC;;AAEA;;EAEE,iDAAiD;EACjD,2DAA2D;AAC7D;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,wCAAwC;EACxC,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;AACxC","sourcesContent":["/**\r\n * ipam.css — Theme-aware overrides for all IPAM / Network components.\r\n * Scoped under .ipam-root to avoid bleeding into other modules.\r\n * Overrides Bootstrap 5 defaults for: cards, tables, nav-tabs, forms, badges.\r\n */\r\n\r\n/* ── Root wrapper ─────────────────────────────────────────────── */\r\n/* OJO: aquí NO se pinta fondo. El módulo hereda el del layout, igual que el\r\n   resto de listados del CMDB. Antes ponía `background: var(--slate-50)` en\r\n   `.ipam-root` y en `.ipam-root > .p-3`, que sobre los skins oscuros dejaba un\r\n   rectángulo más oscuro que la página (se veía como un fondo raro que en las\r\n   demás pantallas no aparece). */\r\n.ipam-root {\r\n  color: var(--text-primary);\r\n  min-height: 100%;\r\n}\r\n\r\n/* ── IPAM Header (tab bar) ────────────────────────────────────── */\r\n.ipam-header {\r\n  background: var(--bg-card) !important;\r\n  border-bottom: 1px solid var(--border) !important;\r\n}\r\n\r\n.ipam-header h5 {\r\n  color: var(--text-primary) !important;\r\n}\r\n\r\n/* ── Nav Tabs ─────────────────────────────────────────────────── */\r\n.ipam-root .nav-tabs {\r\n  border-bottom-color: var(--border) !important;\r\n}\r\n\r\n.ipam-root .nav-tabs .nav-link {\r\n  color: var(--text-muted) !important;\r\n  border-color: transparent !important;\r\n  background: transparent !important;\r\n}\r\n\r\n.ipam-root .nav-tabs .nav-link:hover {\r\n  color: var(--text-secondary) !important;\r\n  border-color: transparent !important;\r\n  background: var(--bg-toolbar) !important;\r\n}\r\n\r\n.ipam-root .nav-tabs .nav-link.active {\r\n  color: var(--accent-l) !important;\r\n  background: transparent !important;\r\n  border-bottom: 2px solid var(--accent) !important;\r\n  border-top-color: transparent !important;\r\n  border-left-color: transparent !important;\r\n  border-right-color: transparent !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n/* ── Page padding wrapper ─────────────────────────────────────── */\r\n/* Sin fondo propio: ver la nota de `.ipam-root`. */\r\n.ipam-root > .p-3 {\r\n  background: transparent;\r\n}\r\n\r\n/* ── Bootstrap cards ──────────────────────────────────────────── */\r\n.ipam-root .card {\r\n  background: var(--bg-card) !important;\r\n  border-color: var(--border) !important;\r\n  color: var(--text-primary) !important;\r\n}\r\n\r\n.ipam-root .card-header {\r\n  background: var(--bg-toolbar) !important;\r\n  border-bottom-color: var(--border) !important;\r\n  color: var(--text-primary) !important;\r\n}\r\n\r\n.ipam-root .card-header strong {\r\n  color: var(--text-primary) !important;\r\n}\r\n\r\n.ipam-root .card-body {\r\n  background: transparent !important;\r\n  color: var(--text-primary) !important;\r\n}\r\n\r\n/* ── List groups (block occupancy) ───────────────────────────── */\r\n.ipam-root .list-group-item {\r\n  background: transparent !important;\r\n  border-color: var(--border) !important;\r\n  color: var(--text-primary) !important;\r\n}\r\n\r\n.ipam-root .list-group-item:hover {\r\n  background: rgba(var(--accent-rgb),.07) !important;\r\n  cursor: pointer;\r\n}\r\n\r\n.ipam-root .list-group-item .text-muted {\r\n  color: var(--text-muted) !important;\r\n}\r\n\r\n/* ── Progress bars ────────────────────────────────────────────── */\r\n.ipam-root .progress {\r\n  background: var(--bg-toolbar) !important;\r\n}\r\n\r\n/* ── Tables ───────────────────────────────────────────────────── */\r\n.ipam-root .table {\r\n  color: var(--text-primary) !important;\r\n  --bs-table-bg: transparent !important;\r\n  --bs-table-striped-bg: var(--bg-toolbar) !important;\r\n  --bs-table-hover-bg: rgba(var(--accent-rgb),.07) !important;\r\n  --bs-table-border-color: var(--border) !important;\r\n}\r\n\r\n.ipam-root .table-light,\r\n.ipam-root thead.table-light,\r\n.ipam-root thead th.table-light,\r\n.ipam-root .table thead,\r\n.ipam-root .table thead tr {\r\n  /* `--bg-surface` (opaco), no `--bg-toolbar`: la cabecera es sticky y con un\r\n     fondo translúcido se ven las filas por debajo al hacer scroll. */\r\n  --bs-table-bg: var(--bg-surface) !important;\r\n  background: var(--bg-surface) !important;\r\n  color: var(--text-secondary) !important;\r\n}\r\n\r\n.ipam-root .table thead th {\r\n  background: var(--bg-surface) !important;\r\n  color: var(--text-secondary) !important;\r\n  border-bottom-color: var(--border) !important;\r\n  font-size: 0.78em;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n}\r\n\r\n.ipam-root .table td,\r\n.ipam-root .table th {\r\n  border-color: var(--border) !important;\r\n}\r\n\r\n.ipam-root .table tbody tr:hover td {\r\n  background: rgba(var(--accent-rgb),.07) !important;\r\n}\r\n\r\n/* ── Form controls ────────────────────────────────────────────── */\r\n.ipam-root .form-control,\r\n.ipam-root .form-select {\r\n  background: var(--bg-input) !important;\r\n  color: var(--text-primary) !important;\r\n  border-color: var(--border) !important;\r\n}\r\n\r\n.ipam-root .form-control:focus,\r\n.ipam-root .form-select:focus {\r\n  background: var(--bg-input) !important;\r\n  color: var(--text-primary) !important;\r\n  border-color: var(--accent) !important;\r\n  box-shadow: 0 0 0 3px rgba(var(--accent-rgb),.2) !important;\r\n}\r\n\r\n.ipam-root .form-control::placeholder {\r\n  color: var(--text-muted) !important;\r\n}\r\n\r\n.ipam-root .form-select option,\r\n.ipam-root .form-control option {\r\n  background: var(--bg-surface);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.ipam-root .form-label {\r\n  color: var(--text-secondary) !important;\r\n}\r\n\r\n/* ── Alerts ───────────────────────────────────────────────────── */\r\n.ipam-root .alert-danger {\r\n  background: rgba(220,38,38,.12) !important;\r\n  border-color: rgba(220,38,38,.25) !important;\r\n  color: #f87171 !important;\r\n}\r\n\r\n/* ── Badges ───────────────────────────────────────────────────── */\r\n.ipam-root .badge.text-bg-secondary {\r\n  background: var(--bg-toolbar) !important;\r\n  color: var(--text-secondary) !important;\r\n}\r\n\r\n.ipam-root .badge.text-bg-primary {\r\n  background: rgba(var(--accent-rgb),.2) !important;\r\n  color: var(--accent-l) !important;\r\n}\r\n\r\n.ipam-root .badge.text-bg-info {\r\n  background: rgba(6,182,212,.15) !important;\r\n  color: #67e8f9 !important;\r\n}\r\n\r\n.ipam-root .badge.text-bg-warning {\r\n  background: rgba(245,158,11,.15) !important;\r\n  color: #fcd34d !important;\r\n}\r\n\r\n.ipam-root .badge.text-bg-success {\r\n  background: rgba(16,185,129,.15) !important;\r\n  color: #6ee7b7 !important;\r\n}\r\n\r\n.ipam-root .badge.text-bg-danger {\r\n  background: rgba(239,68,68,.15) !important;\r\n  color: #fca5a5 !important;\r\n}\r\n\r\n/* ── Text muted ────────────────────────────────────────────────── */\r\n.ipam-root .text-muted {\r\n  color: var(--text-muted) !important;\r\n}\r\n\r\n/* ── Buttons ──────────────────────────────────────────────────── */\r\n.ipam-root .btn-outline-secondary {\r\n  background: var(--bg-toolbar) !important;\r\n  border-color: var(--border) !important;\r\n  color: var(--text-secondary) !important;\r\n}\r\n\r\n.ipam-root .btn-outline-secondary:hover {\r\n  background: var(--bg-input) !important;\r\n  border-color: var(--slate-300) !important;\r\n  color: var(--text-primary) !important;\r\n}\r\n\r\n.ipam-root .btn-outline-danger {\r\n  background: rgba(239,68,68,.08) !important;\r\n  border-color: rgba(239,68,68,.3) !important;\r\n  color: #f87171 !important;\r\n}\r\n\r\n.ipam-root .btn-outline-danger:hover {\r\n  background: rgba(239,68,68,.2) !important;\r\n}\r\n\r\n.ipam-root .btn-link {\r\n  color: var(--accent-l) !important;\r\n}\r\n\r\n.ipam-root .btn-link:hover {\r\n  color: var(--accent) !important;\r\n}\r\n\r\n/* ── KPI cards display text ─────────────────────────────────── */\r\n.ipam-root .text-primary  { color: var(--accent-l) !important; }\r\n.ipam-root .text-secondary { color: var(--text-muted) !important; }\r\n.ipam-root .text-warning  { color: #fcd34d !important; }\r\n.ipam-root .text-success  { color: #6ee7b7 !important; }\r\n.ipam-root .text-danger   { color: #f87171 !important; }\r\n\r\n/* ── Card hover shadow ────────────────────────────────────────── */\r\n.ipam-root .card:hover {\r\n  box-shadow: 0 0 0 1px rgba(var(--accent-rgb),.25) !important;\r\n}\r\n\r\n/* ── Monospace IP addresses ───────────────────────────────────── */\r\n.ipam-root td [style*=\"monospace\"],\r\n.ipam-root td span[style*=\"fontFamily\"] {\r\n  color: var(--accent-l) !important;\r\n}\r\n\r\n/* ── VirtualGroups / generic Bootstrap overrides ─────────────── */\r\n.ipam-root .bg-light,\r\n.ipam-root .bg-white {\r\n  background: var(--bg-toolbar) !important;\r\n}\r\n\r\n.ipam-root .border,\r\n.ipam-root .border-end,\r\n.ipam-root .border-bottom {\r\n  border-color: var(--border) !important;\r\n}\r\n\r\n.ipam-root .table-active,\r\n.ipam-root .table-active td {\r\n  background: rgba(var(--accent-rgb),.1) !important;\r\n  --bs-table-accent-bg: rgba(var(--accent-rgb),.1) !important;\r\n}\r\n\r\n.ipam-root .hover-bg:hover {\r\n  background: rgba(var(--accent-rgb),.07) !important;\r\n}\r\n\r\n.ipam-root .btn-light {\r\n  background: var(--bg-toolbar) !important;\r\n  border-color: var(--border) !important;\r\n  color: var(--text-secondary) !important;\r\n}\r\n\r\n.ipam-root .btn-light:hover {\r\n  background: var(--bg-input) !important;\r\n}\r\n\r\n.ipam-root .bg-secondary.bg-opacity-15 {\r\n  background: var(--bg-toolbar) !important;\r\n}\r\n\r\n.ipam-root .fw-semibold.text-muted.text-uppercase {\r\n  color: var(--text-muted) !important;\r\n}\r\n\r\n.ipam-root .overflow-hidden.rounded.border {\r\n  border-color: var(--border) !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
